import axios from "axios";

import APIRoutes from "../../APIRoutes";
import { SonicUser } from "../../../common/classes/SonicUser";

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * getJikeiManagers
 *
 * Fetching jikei manager data.
 *
 * @param auth_token The user's auth token, used for fetching data that requires certain privileges
 * @param args Acquisition condition object
 * @param args.id ID or array of IDs you wish to fetch
 * @param args.page Current page for pagination
 * @param args.per_page Results per page
 * @param args.sort_by Which parameter us use to filter
 * @param args.desc Whether or not results are ascending or descending
 * @returns Array of user data.
 */

export const getJikeiManagers = async (
  auth_token: string,
  args: {
    id?: string;
    page?: number;
    per_page?: number;
    sort_by?: string;
    desc?: boolean;
  }
) => {
  try {
    const resp = await axios.get(getAPIRoot(APIRoutes.get.manager, "jikei"), {
      headers: {
        "X-Sonic-Auth": auth_token,
      },
      params: {
        id: args.id,
        pg: args.page,
        per: args.per_page,
        sort: args.sort_by,
        desc: args.desc,
      },
    });

    const users: Array<SonicUser> = [];

    resp.data.message.items.forEach((u: any) => {
      const user = SonicUser.parseFromAPIResponse(u);

      users.push({
        ...user,
        meta: { ...user.meta, linked_pages: { ...user.meta.linked_pages } },
      });
    });

    return {
      total_pages: resp.data.message.total_pages,
      page: resp.data.message.page,
      total_entries: resp.data.message.total_entries,
      users: users,
    };
  } catch (e) {
    return null;
  }
};
